import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import { getIgnored, getOutcomeFromDataset, getCorrelationsFromDataset, updateIgnored } from "containers/Setup/reducer";
import { getStep, updateStep } from "containers/CreateWizard/reducer";

import Correlation from "components/CreateWizard/Dataset/Correlation";

const bId = "correlations";

class CorrelationContainer extends React.PureComponent {
  render() {
    const { step, index, transformUpdateDataset } = this.props;

    return <Correlation {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateStep: (step) => dispatch(updateStep(step)),
  updateIgnored: (column, isIgnored) => dispatch(updateIgnored(ownProps.id, column, isIgnored))
});

const mapStateToProps = (state, ownProps) => ({
  correlations: getCorrelationsFromDataset(state, ownProps.id),
  ignored: getIgnored(state, ownProps.id),
  outcome: getOutcomeFromDataset(state, ownProps.id),
  step: getStep(state)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(CorrelationContainer);
